export const TRANSFORM_CENTER = 'translate(-50%, -50%)'
export const TRANSFORM_TO_LEFT = 'translate(-100%, 0)'